<template>
    <div :id="id" class="tree_item_container" v-if="hasChilds || product">
        <p v-if="!product" @click.stop="expand(id, $event)" class="tree-item" :style="itemStyle">
            <span>
                <svg :class="{is_expanded: expanded}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                </svg>
            </span>
            {{ title }}
        </p>
        <template v-else>
            <table class="item_table" :class="{'active': productid && productid === id}" @click="getProduct()">
                <tr class="product-item">
                    <th class="d-flex" style="width: 15%; padding-left: 22px;">
                        {{ article }}
                    </th>
                    <th class="d-flex" style="width: 57%; padding-left: 22px;">
                        {{ title }}
                    </th>
                    <th style="width: 16%; padding-left: 22px; text-align: center;" class="ja-center">{{ price > 0 ? number_format(price, 2, ',', ' ') : 'За запитом' }}</th>
                    <th style="width: 12%; padding-left: 22px; text-align: center;" class="ja-center">{{ qty ? qty + ' ' + (unit ? unit : 'шт.') : 'замовлення' }}</th>
                </tr>
            </table>

            <div class="item_card mobile" :class="{'active': productid && productid === id}" @click="getProduct()">
                <div class="item_card_row">
                    <div class="item_image">
                        <img :src="image ? image : '/img/no_image.png'" height="70" >
                    </div>
                    <div class="item_info">
                        <p class="item_title">{{ product }}</p>
                        <div class="item_row">
                            <span class="item_code">{{ article }}</span>
                            <span class="item_balance"> {{ qty ? qty + ' ' + unit : 'замовлення' }} </span>
                        </div>
                        <div class="item_row_price">
                            <span class="item_price">{{ price > 0 ? (number_format(price, 2, ',', ' ') + ' ' + curr) : 'За запитом' }}</span>
                            <span class="item_details"> Деталі </span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

export default {
    name: "NestedItem",
    emits: ['expand'],
    props: {
        title: {
            type: String
        },
        article: {
            type: String
        },
        price: {
            type: [Number, String]
        },
        qty: {
            type: [Number, String]
        },
        unit: {
            type: String
        },
        product: {
            type: String
        },
        image: {
            type: String,
            default: () => '/img/no_image.png'
        },
        curr: {
            type: String,
            default: () => 'грн'
        },
        id: {
            type: [Number, String]
        },
        productid: {
            type: [Number, String]
        },
        childs: {
            type: Array,
            default: () => []
        },
        selected: {
            type: Array,
            default: () => []
        },
        expanded: {
            type: Boolean,
            default: false
        },
        level: {
            type: Number,
            default: 0
        }
    },

    watch: {
        hasChilds: {
            immediate: true,
            handler: (value, oldValue) => {
                if (!value && oldValue && this.expanded) {
                    context.emit('expand', {
                        expand: false,
                        id: this.id
                    })
                }
            }
        }
    },

    computed: {
        itemStyle() {
            return { 'padding-left': this.level * 1.8 + 'em' };
        },
        hasChilds() {
            return !!this.childs.length
        },
    },

    methods: {
        expand(id, event) {
            if (!this.hasChilds) return
            const expanded = !this.expanded;
            this.$emit('expand', { expanded, id: this.id });
        },
        getProduct(id, event) {
            this.$emit('getproduct', { id: this.id });
        },
        number_format(number, decimals, dec_point, thousands_sep) {
            // Strip all characters but numerical ones.
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        }
    },
}
</script>

<style scoped>
.ja-center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.tree-item {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 27px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #212529;
    cursor: pointer;
    margin: 0 25px 0 25px;
}

.tree_item_container {
    border-bottom: 1px solid #C8E4FF;
}

.is_expanded {
    transform: rotate(180deg);
}

.tree_item_container:hover {
    background: #C8E4FF;
}

.item_table {
    width: 100%;
    text-align: left;
}

.item_table tr {
    display: flex;
}

.item_table th {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    word-break: break-word;
}

.d-flex {
    display: flex;
    align-items: center;
    gap: 11px;
}

.product-item {
    cursor: pointer;
}

.item_card.mobile {
    display: none;
    padding: 10px;
}

.item_card.active {
    background-color: #C8E4FF;
}

.item_table.active {
    background-color: #C8E4FF;
}

.item_card_row {
    display: flex;
    gap: 20px;
}

.item_title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin: 0;
    padding-bottom: 5px;
}

.item_code {
    color: rgba(33, 37, 41, 0.40);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

.item_balance {
    color: #356EEF;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
}

.item_row {
    display: flex;
    gap: 4px;
    padding-bottom: 8px;
}

.item_price {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
}

.item_details {
    color: #356EEF;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    text-decoration-line: underline;
}

.item_row_price {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

@media (max-width: 800px) {
    .item_table {
        display: none!important;
    }
    .item_card.mobile {
        display: block;
    }
    .tree-item {
        height: auto;
        padding: 5px 0px;
    }
}
</style>
